import { combineReducers } from 'redux';
import userReducer from './admin/userReducer';

const rootReducer = combineReducers({
	user: userReducer,
});

export default rootReducer;
